import { render, staticRenderFns } from "./floatIcon.vue?vue&type=template&id=0b24d80b&scoped=true&"
import script from "./floatIcon.vue?vue&type=script&lang=js&"
export * from "./floatIcon.vue?vue&type=script&lang=js&"
import style0 from "./floatIcon.vue?vue&type=style&index=0&id=0b24d80b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24d80b",
  null
  
)

component.options.__file = "floatIcon.vue"
export default component.exports